<!--
入力内容表示コンポーネント
病歴を表示
true : YES
false : NO
-->
<template>
  <div class="yes-no-container">
    <div :class="{ active: value }" :data-test="`${dataTest}-yes`">YES</div>
    <div>/</div>
    <div :class="{ active: !value }" :data-test="`${dataTest}-no`">NO</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    dataTest: String
  }
};
</script>

<style scoped>
.yes-no-container {
  display: flex;
}
.active {
  color: #77b5e8;
}
</style>
